/**
 * Home page entry point.
 *
 * Finds the elements, asks once whether the visitor wants less motion, and hands both to
 * the behaviours. Everything here is enhancement: the page renders and reads fine with
 * this file blocked, and each behaviour is inert if its element isn't on the page.
 */

import { initChat } from './chat.js';
import { initHotlink } from './hotlink.js';
import { initLightbox } from './lightbox.js';
import { initNowPlaying } from './now-playing.js';
import { initParallax } from './parallax.js';
import { initPresence } from './presence.js';
import { initSlideshow } from './slideshow.js';
import { initStats } from './stats.js';
import { initStatus } from './status.js';
import { initThemeToggle } from './theme-toggle.js';
import { initTickers } from './ticker.js';
import { initVisitor } from './visitor.js';

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

initSlideshow(document.querySelector('.visual'), { reducedMotion });
initParallax({ reducedMotion });
initThemeToggle(document.querySelector('.theme-toggle'));
initTickers({ reducedMotion });
initVisitor(document.querySelector('.chip--visitor'));
initHotlink(document.querySelector('.card--hotlink'));
initChat(document.querySelector('.side--chat'));
initNowPlaying(document.querySelector('.np'));
initStatus(document.querySelector('.status'));
initLightbox(document.querySelector('.lightbox'), document.querySelector('.fav-grid'));

// The readout hands back its "here now" cell so the socket can keep it current.
const { setHere } = initStats(document.querySelector('.readout'));
initPresence({ canvas: document.querySelector('.constellation'), onCount: setHere });
